import { useEffect, useRef, useState } from 'react';
import { useUser } from '../../contexts/UserContext';
import { useNavigate } from "react-router-dom";
import { useModal } from "../../contexts/ModalContext";
import { TiUserOutline } from "react-icons/ti";
import { ReactComponent as UploadIcon } from '../../assets/HomePage/upload-icon.svg';

export default function UserMenu() {
  const [open, setOpen] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);
  const { user, logout, handleFetchAvatar } = useUser();
  const navigate = useNavigate();
  const { openModal } = useModal();

  const clearCloseTimeout = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }
  };

  const handleMouseLeave = () => {
    clearCloseTimeout();
    timeoutRef.current = setTimeout(() => {
      setOpen(false);
    }, 300);
  };

  return (
    <div className="relative flex items-center space-x-4" ref={menuRef}>
      {/* Avatar Button */}
      <div
        onMouseEnter={() => {
          clearCloseTimeout();
          setOpen(true);
        }}
        onMouseLeave={handleMouseLeave}
        className="relative"
      >
        <button
          type="button"
          onClick={() => setOpen((prev) => !prev)}
          className={`flex text-sm rounded-full border-2 transition ${open ? "border-secondary" : "border-transparent"
            }`}
        >
          {user?.avatar &&
            <img
              className="w-8 h-8 rounded-full"
              src={user.avatar}
              alt="user avatar"
              onError={() => handleFetchAvatar(user.userId)}
            />
          }
          {!user?.avatar &&
            <TiUserOutline className="w-8 h-8 text-white rounded-full" />
          }
        </button>

        {/* Dropdown menu */}
        {open && (
          <div
            onMouseEnter={clearCloseTimeout}
            onMouseLeave={handleMouseLeave}
            className="absolute top-full left-1/2 -translate-x-1/2 z-50 mt-2 w-48 bg-primary rounded-xl shadow-xl ring-8 ring-primary/40 divide-y divide-primaryAlt"
          >
            <div className="px-4 py-3 shadow-lg bg-primary">
              <span className="block text-sm text-white">
                {user?.name || user?.email || "User"}
              </span>
              <span className="block text-sm text-secondary truncate">
                {user?.email}
              </span>
            </div>
            <ul className="py-2" aria-labelledby="user-menu-button">
              <li>
                <a href="/dashboard" className="user-menu-item">Dashboard</a>
              </li>
              <li>
                <button
                  onClick={logout} className="w-full text-left user-menu-item">Sign out
                </button>
              </li>
            </ul>
          </div>
        )}
      </div>

      {/* Upload Button */}
      <button
        onClick={() => openModal("upload", {}, "Upload", "xl")}
        className="flex items-center rounded-btn"
      >
        <UploadIcon className="w-5 h-5 -ml-1 text-current" />
        Upload
      </button>
    </div>
  );
}